var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EBF8FF",
  d: "M10 6.54V9q0 1.5-1.5 1.5H7.165a.15.15 0 0 1-.15-.15V8.811c0-.498-.337-.963-.829-1.046a1.003 1.003 0 0 0-1.17.985v1.6a.15.15 0 0 1-.15.15H3.5Q2 10.5 2 9V6.54c.295.14.62.21.95.21.57 0 1.115-.2 1.535-.53.42.33.96.53 1.515.53.56 0 1.1-.2 1.52-.53.42.33.965.53 1.535.53.325 0 .65-.07.945-.21M3.75 1.5c-1.25 0-1.441.41-1.647 1.019l-.52 1.537c-.22.646.002 1.395.6 1.74.224.13.486.204.767.204.665 0 1.32-.415 1.527-1 .203.585.858 1 1.523 1s1.32-.415 1.522-1c.208.585.863 1 1.528 1 .28 0 .543-.074.767-.204.597-.345.819-1.094.6-1.74l-.52-1.537C9.692 1.91 9.5 1.5 8.25 1.5z"
})));
export default SvgStore;